import React from "react";
import { useHardwareBackHandler } from "../navigation/HardwareBackContext";
import "./styles/productEducation.css";

export function EducationLauncherMenu({
  onClose,
  onOpenWhatsNew,
  onOpenUserPreferences,
}) {
  useHardwareBackHandler(() => {
    onClose?.();
    return true;
  }, true);

  return (
    <div className="pep-overlay" role="dialog" aria-modal="true" aria-labelledby="pep-launcher-title">
      <div className="pep-panel">
        <div className="pep-panel__header">
          <p className="pep-panel__eyebrow">Help &amp; Learning</p>
          <h2 id="pep-launcher-title" className="pep-panel__title">
            How can I help?
          </h2>
        </div>
        <div className="pep-panel__actions">
          <button
            type="button"
            className="pep-btn pep-btn--primary pep-launcher-menu__item"
            onClick={() => {
              onClose?.();
              onOpenWhatsNew?.();
            }}
          >
            What&apos;s New
          </button>
          {onOpenUserPreferences ? (
            <button
              type="button"
              className="pep-btn pep-btn--secondary pep-launcher-menu__item"
              onClick={() => {
                onClose?.();
                onOpenUserPreferences();
              }}
            >
              Settings
            </button>
          ) : null}
          <button type="button" className="pep-btn pep-btn--ghost" onClick={onClose}>
            Close
          </button>
        </div>
      </div>
    </div>
  );
}
